import { HttpParams } from '@angular/common/http';
import { ReflectionParams } from './reflection.value';

type QueryParams = Record<string, string>;

export class ReflectionParamsDto {
    private readonly query: QueryParams = {};

    constructor(params: ReflectionParams) {
        if (params.pathwayId) this.query['pathwayId'] = params.pathwayId;
        if (params.courseId) this.query['courseId'] = params.courseId;
        if (params.moduleId) this.query['moduleId'] = params.moduleId;
    }

    get params(): HttpParams {
        return new HttpParams({ fromObject: this.query });
    }
}
